export const environment = {
  production: false,
  apiUrl: 'https://api.professores.test.betha.cloud/api',
  apiUrlAnexos: '/zuul/api',
  systemId: 113,
  // client_id real: credencial "Professores PWA" cadastrada DENTRO do projeto
  // "Professores" (systemId 113) no Studio Aplicações — mesmo projeto do client
  // legado do AngularJS, não um projeto novo/separado (PROF-13326).
  //
  // Retificação: por um tempo este valor foi trocado pra '3c9953ba-a75a-43ca-
  // a185-de0954338e68', achado num projeto NOVO/separado (id 463) criado por
  // engano fora da hierarquia do projeto "Professores". Esse client tem o
  // atributo `sistema` registrado como 462 (não 113) — confirmado via
  // introspecção real do token (GET .../auth/oauth2/tokeninfo) — causando 401
  // "Acesso de usuário invalido" em toda chamada a api.professores.*
  // (UserAccessEntityHash.decode exige o mesmo systemId usado na geração do
  // licenseId). Revertido de volta pro valor original, confirmado pelo usuário
  // como o cadastrado no projeto certo.
  oauthClientId: '4f0ee5d3-8b67-4602-aa57-54d0dba85260',
  // my-preferences.suite autorizado no Studio Aplicações pro client_id (PROF-13326,
  // confirmado via /authorize real: login page em vez de invalid_scope). Não há
  // consumidor deste scope neste repo ainda (LAST_STATE não existe aqui) — reservado
  // pra quando essa feature for portada do repo legado.
  oauthScopes: 'contas-usuarios.suite user-accounts.suite notifications.suite ambiente-professores gerenciador-relatorios.suite naturezas.suite gerenciador-scripts.suite dados.suite feedback.suite licenses.suite my-preferences.suite',
  oauthBaseUrl: 'https://plataforma-oauth.test.betha.cloud/auth/oauth2',
  identificadorCamposAdicionaisPlanoEnsino: 'CriciumaIdentity'
};
